import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  RouteChildrenProps,
  Switch,
} from "react-router-dom";
import "./App.css";
import { BakeCard, Header, RegisterCard, SessionsCard } from "./components";
import useBakeService from "./services/useBakeService";
import { BakeImage, Card, CardContainer } from "./styling/card";
import { Footer } from "./components";
import styled from "styled-components";

interface SessionRouteProps {
  bakeID: number;
}

interface RegisterRouteProps {
  sessionID: number;
  onWaitingList: boolean;
}

const BodyContent = styled.div`
  flex: 1 0 auto;
`;

const App = () => {
  const { bakeData } = useBakeService();

  return (
    <>
      <BodyContent>
        <Header />
        <CardContainer>
          <Card>
            {bakeData && <BakeImage imageURL={bakeData.image} />}
            <Router>
              <Switch>
                <Route
                  path="/sessions"
                  component={(
                    props: RouteChildrenProps<{}, SessionRouteProps>
                  ) =>
                    props.location.state?.bakeID ? (
                      <SessionsCard bakeID={props.location.state.bakeID} />
                    ) : (
                      <Redirect to="/" />
                    )
                  }
                />
                <Route
                  path="/register"
                  component={(
                    props: RouteChildrenProps<{}, RegisterRouteProps>
                  ) =>
                    props.location.state?.sessionID ? (
                      <RegisterCard
                        sessionID={props.location.state.sessionID}
                        onWaitingList={props.location.state.onWaitingList}
                      />
                    ) : (
                      <Redirect to="/" />
                    )
                  }
                />
                <Route
                  path="/admin"
                  component={() => {
                    window.location.href =
                      "https://www.bakesoc.tk/admin";
                    return null;
                  }}
                />
                <Route exact path="/" render={() => <BakeCard />} />
                <Redirect to="/" />
              </Switch>
            </Router>
          </Card>
        </CardContainer>
      </BodyContent>
      <Footer />
    </>
  );
};

export default App;
